import { z } from 'zod';

export const painelGerencialMiniSchema = z.object({
  nome: z.string().trim().min(1, 'Informe o nome do item'),
  url: z.string().trim().min(1, 'Informe o caminho'),
});

export const painelGerencialFormSchema = z.object({
  nome: z.string().trim().min(1, 'Informe o nome'),
  descricao: z
    .string()
    .trim()
    .optional()
    .transform((v) => (v === '' ? undefined : v)),
  areaResponsavel: z.string().trim().min(1, 'Informe a área responsável'),
  url: z
    .string()
    .trim()
    .min(1, 'Informe a URL base')
    .url('Informe uma URL válida (http/https)'),
  ativo: z.boolean().default(true),
  minis: z.array(painelGerencialMiniSchema).default([]),
  usuarioIds: z.array(z.number().int().positive()).default([]),
});

export type PainelGerencialFormValues = z.infer<typeof painelGerencialFormSchema>;

export function normalizeUrlBase(base: string): string {
  return base.trim().replace(/\/$/, '');
}

export function miniUrlToSuffix(fullUrl: string, base: string): string {
  const normalizedBase = normalizeUrlBase(base);
  const raw = fullUrl.trim();
  if (normalizedBase && raw.toLowerCase().startsWith(normalizedBase.toLowerCase())) {
    const rest = raw.slice(normalizedBase.length);
    return rest.startsWith('/') ? rest : rest ? `/${rest}` : '/';
  }
  try {
    const parsed = new URL(raw);
    return `${parsed.pathname}${parsed.search}${parsed.hash}` || '/';
  } catch {
    return raw.startsWith('/') ? raw : `/${raw}`;
  }
}

export function miniSuffixToUrl(base: string, suffix: string): string {
  const normalizedBase = normalizeUrlBase(base);
  const rest = suffix.trim();
  if (!rest) return normalizedBase;
  if (/^https?:\/\//i.test(rest)) return rest;
  if (!normalizedBase) return rest.startsWith('/') ? rest : `/${rest}`;
  return rest.startsWith('/')
    ? `${normalizedBase}${rest}`
    : `${normalizedBase}/${rest}`;
}
